// Redux action types
export const SET = 'one-state-apptreasoncode/set';
export const REINIT = 'one-state-apptreasoncode/reinit';